import MaterialReactTable from "material-react-table";
import React, { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import {  } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import axios from "axios";
import cogoToast from "cogo-toast";
import { format, parseISO } from "date-fns";
import { download, generateCsv, mkConfig } from "export-to-csv"; // Import export-to-csv functionalities
import { useEffect } from "react";
import { RiFolderSharedLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import {
  AWS_Access_Key_Id,
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import { ClearCacheApi, FileLoader, UploadApi } from "../constants/Constants";
import CustomizedSnackbars from "./CustomizedSnackbars";
import "./DataablePage.css";

const DatatablePage = ({ data, mod, setformation, goBack }) => {
  const [open, setopen] = useState(false);
  const { modality, lab, subFolder } = useParams();
  const [modalFolder, setModalFolder] = useState(false);
  const [FolderList, setFolderList] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50, //customize the default page size
  });
  const [selectedFolder, setSelectedFolder] = useState("");
  const [subFolderList, setSubFolderList] = useState([]);
  const [subFolderName, setSubFolder] = useState("");
  const [thirdSubFolderList, setThirdSubFolderList] = useState([]);
  const [thirdSubFolderName, setThirdSubFolder] = useState("");
  const [fourthSubFolderList, setFourthSubFolderList] = useState([]);
  const [fourthSubFolderName, setFourthSubFolder] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const canShare = useSelector((state) => state.canShare);
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const [copyEnabled, setCopyEnabled] = useState(false);
  const navigate = useNavigate();
  //console.log(selectedRows,"selectedRowsselectedRows");

  const csvConfig = mkConfig({
    fieldSeparator: ",",
    decimalSeparator: ".",
    useKeysAsHeaders: true,
  });
  const [isOpen, setIsOpen] = React.useState(false);
  const [severity, setSeverty] = React.useState("success");
  const [message, setMessage] = React.useState("");

  const [isShared, setIsShared] = useState(false);
  useEffect(() => {
    const value = localStorage.getItem("jkbnm");
    const getValue = value === "dmewtnwkndghn" ? true : false;
    setIsShared(getValue);
  }, []);

  const handleExportAllData = () => {
    const dataWithoutActions = data.map((item) => {
      const { action0, ...rest } = item;
      return rest;
    });
    const csv = generateCsv(csvConfig)(dataWithoutActions);
    download(csvConfig)(csv);
  };

  const handleExportPageRows = (rows) => {
    const csvData = removeActionsField(rows.map((row) => row.original));
    exportDataToCsv(csvData);
  };

  const handleExportRows = (rows, visibleColumns) => {
    const filteredData = rows.map((row) => {
      const rowData = row.original;
      const filteredRowData = {};

      // Include only visible columns
      visibleColumns.forEach((col) => {
        const accessor = col.columnDef.accessorKey; // Access the accessor key
        if (accessor && rowData.hasOwnProperty(accessor)) {
          filteredRowData[accessor] = rowData[accessor];
        }
      });
      return filteredRowData;
    });

    exportDataToCsv(removeActionsField(filteredData));
  };

  const exportDataToCsv = (data) => {
    const csvConfig = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      title: "Exported Data",
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    };

    const csv = generateCsv(csvConfig)(data);
    download(csvConfig)(csv);
  };

  const removeActionsField = (data) => {
    return data.map((item) => {
      const { action, ...rest } = item;
      return rest;
    });
  };

  const getOnlyShareFolders = async () => {
    try {
      let sanitizedFolderName = "";
      if (typeof FolderGet === "string") {
        sanitizedFolderName = FolderGet;
      } else if (Array.isArray(FolderGet)) {
        sanitizedFolderName = FolderGet.join(",");
      }
      const data = {
        folderName: sanitizedFolderName,
        bucketName: AWS_Bucket_Name(),
       
        Region: AWS_Region(),
      };

      const response = await axios.post(
        `${UploadApi}/apiUpload/only-share`,
        data
      );

      if (response.data) {
        setFolderList(response.data);
      } else {
        setFolderList([]);
      }
    } catch (error) {
      console.error(error);
      setFolderList([]);
    }
  };

  const FolderListGet = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetFolderList/?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          headers: {
            Authorization: `Bearer ${token}`, // Replace 'yourAccessToken' with the actual access token
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const GetFolderList = await response.json();
      let folderList = GetFolderList;
      const currentFolder = window.location.href.split("/")[4];
      if (currentFolder && currentFolder !== "undefined") {
        folderList = GetFolderList.filter(
          (item) => item !== "archive" && item !== "Multi"
        );
        setFolderList(folderList);
      } else {
        setFolderList(GetFolderList);
      }

      // Process folderList data as needed
      // Set state or perform any other actions with the folder data
    } catch (error) {
      //console.error("Error fetching folder data:", error);
    }
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "name", //simple recommended way to define a column
        header: "Patient Name",
      },
      {
        accessorKey: "modalityDes", //simple recommended way to define a column
        header: "Modality Description",
      },
      {
        accessorKey: "Study Date", // simple recommended way to define a column
        header: "Study Date",
        Cell: ({ cell }) =>
          cell.getValue() && format(parseISO(cell.getValue()), "dd/MM/yyyy"), // corrected property access
        sortingFn: (a, b) =>
          new Date(a.original["Study Date"]) -
          new Date(b.original["Study Date"]), // ensure correct field access
      },
      {
        accessorKey: "action", //simple recommended way to define a column
        header: "Actions",
      },
    ],
    []
  );
  const formated = lab?.split("%");

  const handleFolderChange = (event) => {
    setSelectedFolder(event.target.value);
  };

  const handleSubFolderChange = (event) => {
    setSubFolder(event.target.value);
  };

  const handleThirdSubFolderChange = (event) => {
    setThirdSubFolder(event.target.value);
  };

  const handleFourthSubFolderChange = (event) => {
    setFourthSubFolder(event.target.value);
  };

  const clear_cache = (selected_rows) => {
    // Collect all ssuid values that need to be removed
    const ssuidsToRemove = selected_rows.map((row) => row.ssuid);

    // Filter out all items that match any ssuid in the list
    const updatedData = data.filter(
      (item) => !ssuidsToRemove.includes(item.ssuid)
    );

    // Make API calls for each row
    selected_rows.forEach((row) => {
      const { ssuid, foldername } = row;
      const suid = `${foldername}/${ssuid}`;

      axios
        .get(`${ClearCacheApi}/clear_cache`, { params: { suid } })
        .then((response) => {
          console.log(`GET API call successful for suid: ${suid}`);
        })
        .catch((error) => {
          console.error(`Error fetching data for suid: ${suid}`, error);
        });
    });

    setformation(updatedData);
    if (updatedData.length == 0) {
      goBack();
    }
    setSelectedRows([]);
  };

  const handleDivClick = ({ table }) => {
    if (table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) {
      setSelectedRows(
        removeActionsField(
          table?.getSelectedRowModel()?.rows.map((row) => row?.original)
        )
      );
      FolderListGet();
      setModalFolder(true);
    }
  };

  const handleDivCopyClick = ({ table }) => {
    if (table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) {
      setSelectedRows(
        removeActionsField(
          table?.getSelectedRowModel()?.rows.map((row) => row?.original)
        )
      );
      getOnlyShareFolders();
      setModalFolder(true);
    }
  };

  const MoveFolder = async () => {
    if (selectedFolder === "") {
      cogoToast.warn("Select a folder to move!", {
        position: "top-right",
      });
      return;
    }
    if (subFolderName === "" && subFolderList.length > 0) {
      cogoToast.warn("Select a sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    if (thirdSubFolderName === "" && thirdSubFolderList.length > 0) {
      cogoToast.warn("Select a 3rd level sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    if (fourthSubFolderName === "" && fourthSubFolderList.length > 0) {
      cogoToast.warn("Select a 4th level sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    const token = localStorage.getItem("token");
    let formData = new FormData();
    formData.append("awsAccessKeyId", AWS_Access_Key_Id_Encypt());
    formData.append("awsSecretAccessKey", AWS_Secret_Access_Key_Encypt());
    selectedRows?.map((item, i) => {
      formData.append(`CopyDetail[${i}].Suid`, item?.ssuid);
      formData.append(`CopyDetail[${i}].foldername`, item?.foldername + "/");
    });
    formData.append("awsbucketname", AWS_Bucket_Name());
    formData.append("Region", AWS_Region());

    try {
      let response = await axios.post(
        `${FileLoader}/fileloaderv1/files/CopyDatabySUID?FolderName=${encodeURIComponent(
          selectedFolder +
            (subFolderName !== "" ? "/" + subFolderName : "") +
            (thirdSubFolderName !== "" ? "/" + thirdSubFolderName : "") +
            (fourthSubFolderName !== "" ? "/" + fourthSubFolderName : "")
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response) {
        clear_cache(selectedRows);
        setModalFolder(false);
        setIsOpen(true);
        setMessage("Study Moved Successfully");
        // setSeverty("error");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      }
    } catch (error) {
      //console.log(error);
    }
  };

  const CopyToFolder = async () => {
    if (selectedFolder === "") {
      cogoToast.warn("Select a folder to move!", {
        position: "top-right",
      });
      return;
    }
    if (subFolderName === "" && subFolderList.length > 0) {
      cogoToast.warn("Select a sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    if (thirdSubFolderName === "" && thirdSubFolderList.length > 0) {
      cogoToast.warn("Select a 3rd level sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    if (fourthSubFolderName === "" && fourthSubFolderList.length > 0) {
      cogoToast.warn("Select a 4th level sub folder to move!", {
        position: "top-right",
      });
      return;
    }

    const formData = new FormData();
    
    formData.append("bucketName", AWS_Bucket_Name());
    formData.append("region", AWS_Region());

    const folderDetails = selectedRows?.map((item) => ({
      suid: item?.ssuid,
      folderName: item?.foldername,
    }));

    formData.append("folderDetails", JSON.stringify(folderDetails));

    try {
      const response = await axios.post(
        `${UploadApi}/apiUpload/copyFilesTo?toFolderName=${encodeURIComponent(
          `${selectedFolder}${subFolderName !== "" ? "/" + subFolderName : ""}${
            thirdSubFolderName !== "" ? "/" + thirdSubFolderName : ""
          }${fourthSubFolderName !== "" ? "/" + fourthSubFolderName : ""}`
        )}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        setModalFolder(false);
        setIsOpen(true);
        setMessage("Study Copied Successfully");
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const GetSubFolderList = async () => {
    let token = localStorage.getItem("token");
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${selectedFolder}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let res = await response.json();

      if (res.status === 401) {
        localStorage.removeItem("token");
        navigate("/signin");
      }

      const filteredRes = res.filter((element) => !element.includes("."));
      const toMatchList = filteredRes.map(
        (item) => `${selectedFolder}/${item}`
      );

      const finalList = selectedRows.map((item) => item.foldername);

      // filter out matches, then strip `${selectedFolder}/`
      const filteredList = toMatchList
        .filter((item) => !finalList.includes(item))
        .map((item) => item.replace(`${selectedFolder}/`, ""));

      setSubFolder("");
      setSubFolderList(filteredList);
    } catch (error) {
      setSubFolder("");
      setSubFolderList([]);
      console.log(error);
    }
  };

  const GetThirdSubFolderList = async () => {
    let token = localStorage.getItem("token");
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${`${
          selectedFolder + "/" + subFolderName
        }`}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let res = await response.json();

      if (res.status === 401) {
        localStorage.removeItem("token");
        navigate("/signin");
      }

      const filteredRes = res.filter((element) => !element.includes("."));

      const toMatchList = filteredRes.map(
        (item) =>
          `${selectedFolder}${
            subFolderName !== "" ? "/" + subFolderName : ""
          }/${item}`
      );

      const finalList = selectedRows.map((item) => item.foldername);

      console.log(toMatchList, finalList);

      // filter out matches, then strip `${selectedFolder}/`
      const filteredList = toMatchList
        .filter((item) => !finalList.includes(item))
        .map((item) =>
          item.replace(
            `${selectedFolder}${
              subFolderName !== "" ? "/" + subFolderName : ""
            }/`,
            ""
          )
        );
      setThirdSubFolder("");
      setThirdSubFolderList(filteredList);
    } catch (error) {
      setThirdSubFolder("");
      setThirdSubFolderList([]);
      console.log(error);
    }
  };

  const GetFourthSubFolderList = async () => {
    let token = localStorage.getItem("token");
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt()
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt()
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${`${
          selectedFolder + "/" + subFolderName + "/" + thirdSubFolderName
        }`}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let res = await response.json();

      if (res.status === 401) {
        localStorage.removeItem("token");
        navigate("/signin");
      }

      const filteredRes = res.filter((element) => !element.includes("."));

      const toMatchList = filteredRes.map(
        (item) =>
          `${selectedFolder}${subFolderName !== "" ? "/" + subFolderName : ""}${
            thirdSubFolderName !== "" ? "/" + thirdSubFolderName : ""
          }/${item}`
      );

      const finalList = selectedRows.map((item) => item.foldername);

      // filter out matches, then strip `${selectedFolder}/`
      const filteredList = toMatchList
        .filter((item) => !finalList.includes(item))
        .map((item) =>
          item.replace(
            `${selectedFolder}${
              subFolderName !== "" ? "/" + subFolderName : ""
            }${thirdSubFolderName !== "" ? "/" + thirdSubFolderName : ""}/`,
            ""
          )
        );

      setFourthSubFolder("");
      setFourthSubFolderList(filteredList);
    } catch (error) {
      setFourthSubFolder("");
      setFourthSubFolderList([]);
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedFolder != "") {
      GetSubFolderList();
    }
  }, [selectedFolder]);

  useEffect(() => {
    if (subFolderName != "") {
      GetThirdSubFolderList();
    }
  }, [subFolderName]);

  useEffect(() => {
    if (thirdSubFolderName != "") {
      GetFourthSubFolderList();
    }
  }, [thirdSubFolderName]);

  return (
    <>
      <div style={{ background: "rgba(0, 0, 0, 0.12)", marginTop: "-10px" }}>
        <Dialog
          open={modalFolder}
          onClose={() => setModalFolder(false)}
          style={{ height: subFolderList.length > 0 ? "75%" : "60%" }}
          PaperProps={{
            style: {
              height: "60%",
            },
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle style={{ margin: "auto", color: "#1976D2" }}>
            {copyEnabled ? "Copy Study To" : "Move Study To"}
          </DialogTitle>
          <DialogContent style={{ overflowX: "hidden", marginLeft: 5 }}>
            <DialogContentText id="alert-dialog-slide-description">
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Grid container spacing={2} style={{ marginTop: "-35px" }}>
                  <Grid item lg={12} style={{ paddingLeft: 23 }}>
                    <br />
                    <TextField
                      select
                      value={selectedFolder}
                      onChange={handleFolderChange}
                      autoFocus
                      hiddenLabel
                      required
                      label="Select Folder to move"
                      variant="outlined"
                      size="small"
                      style={{
                        borderRadius: "3px",
                        backgroundColor: "white",
                        width: 538,
                        marginTop: "5px",
                      }}
                    >
                      {/* Replace the values and labels with your folder options */}
                      {FolderList?.map((value, index) => (
                        <MenuItem key={index} value={value}>
                          {canShare ? value.split("--ONLYSHARE--")[0] : value}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  {subFolderList.length > 0 && (
                    <Grid item lg={12} style={{ paddingLeft: 23 }}>
                      <TextField
                        select
                        value={subFolderName}
                        onChange={handleSubFolderChange}
                        autoFocus
                        hiddenLabel
                        required
                        label="Select Sub Folder to move"
                        variant="outlined"
                        size="small"
                        style={{
                          borderRadius: "3px",
                          backgroundColor: "white",
                          width: 538,
                          marginTop: "5px",
                        }}
                      >
                        {/* Replace the values and labels with your folder options */}
                        {subFolderList?.map((value, index) => (
                          <MenuItem key={index} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}
                  {thirdSubFolderList.length > 0 && (
                    <Grid item lg={12} style={{ paddingLeft: 23 }}>
                      <TextField
                        select
                        value={thirdSubFolderName}
                        onChange={handleThirdSubFolderChange}
                        autoFocus
                        hiddenLabel
                        required
                        label="Select 3rd Level Sub Folder to move"
                        variant="outlined"
                        size="small"
                        style={{
                          borderRadius: "3px",
                          backgroundColor: "white",
                          width: 538,
                          marginTop: "5px",
                        }}
                      >
                        {/* Replace the values and labels with your folder options */}
                        {thirdSubFolderList?.map((value, index) => (
                          <MenuItem key={index} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}

                  {fourthSubFolderList.length > 0 && (
                    <Grid item lg={12} style={{ paddingLeft: 23 }}>
                      <TextField
                        select
                        value={fourthSubFolderName}
                        onChange={handleFourthSubFolderChange}
                        autoFocus
                        hiddenLabel
                        required
                        label="Select 4th Level Sub Folder to move"
                        variant="outlined"
                        size="small"
                        style={{
                          borderRadius: "3px",
                          backgroundColor: "white",
                          width: 538,
                          marginTop: "5px",
                        }}
                      >
                        {/* Replace the values and labels with your folder options */}
                        {fourthSubFolderList?.map((value, index) => (
                          <MenuItem key={index} value={value}>
                            {value}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ marginRight: "22px", marginBottom: "10px" }}>
            <Button onClick={() => setModalFolder(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                copyEnabled ? CopyToFolder() : MoveFolder();
                // createFolder();
                // setLoader(false);
              }}
            >
              {copyEnabled ? "Copy" : "Move"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <MaterialReactTable
        columns={columns}
        data={data}
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 25, 50, 75, 100],
          showFirstLastPageButtons: false,
        }}
        enableRowSelection={true}
        onPaginationChange={setPagination}
        state={{ pagination }}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            className="iqrarafiq"
            sx={{
              display: "flex",
              gap: "16px",
              padding: "8px",
              flexWrap: "wrap",
            }}
          >
            <div
              className="iqraraa"
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h3 style={{ color: "#3989d8", marginLeft: "auto" }}>
                  Study List
                  {/* {formated && (
                  <span>
                    /{formated}
                    {subFolder ? "/" + subFolder : null}
                    {modality ? "/" + modality : null}
                  </span>
                )}{" "} */}
                </h3>
              </div>
              {/* <div
                className="absolute right-0 top-7 cursor-pointer"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleDivClick({ table })}
              >
                <RiFolderSharedLine
                  disabled={
                    !table.getIsSomeRowsSelected() &&
                    !table.getIsAllRowsSelected()
                  }
                  style={{
                    marginTop: "-13px",
                    marginRight: "7px",
                  }}
                />
              </div> */}
            </div>

            <Button
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              sx={{ textTransform: "capitalize" }}
              onClick={() => {
                const visibleColumns = table.getVisibleLeafColumns();
                handleExportRows(
                  table.getSelectedRowModel().rows,
                  visibleColumns
                );
              }}
              startIcon={<FileDownloadIcon color="white" />}
              variant="contained"
            >
              Export Selected Rows
            </Button>
            {!isShared && (
              <Button
                sx={{ textTransform: "capitalize" }}
                disabled={
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected()
                }
                //only export selected rows
                onClick={() => {
                  setCopyEnabled(false);
                  handleDivClick({ table });
                }}
                startIcon={<RiFolderSharedLine />}
                variant="contained"
              >
                Move Files
              </Button>
            )}
            {canShare || !isShared ? (
              <Button
                sx={{ textTransform: "capitalize" }}
                disabled={
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected()
                }
                //only export selected rows
                onClick={() => {
                  setCopyEnabled(true);
                  isShared
                    ? handleDivCopyClick({ table })
                    : handleDivClick({ table });
                }}
                startIcon={<RiFolderSharedLine />}
                variant="contained"
              >
                Copy To
              </Button>
            ) : (
              ""
            )}
          </Box>
        )}
        initialState={{ density: "compact" }}
        enableDensityToggle={false}
        columnResizeMode={true}
        enableFullScreenToggle={true}
      />
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </>
  );
};

export default DatatablePage;
